import{StyleSheet}from"react-native";export const styles=StyleSheet.create({container:{backgroundColor:"white",borderRadius:15}});